import IconArrowBack from '@/components/icons/arrowBack.vue'
   import IconBase from '@/components/IconBase.vue'
   import IconForwardBack from '@/components/icons/arrowForward.vue'

   export default {
      $_veeValidate: {
         validator: 'new'
      },
       name: "ServiceResidentialMailing",
       components: {
           IconArrowBack,
           IconBase,
           IconForwardBack
       },
       data: () => ({
          residential_street_number: "",
          residential_street_address: "",
          residential_postcode: "",
          residential_suburb: "",
          residential_state: "",
          issameaddress: true,
          mailing_street_number: "",
          mailing_street_address: "",
          mailing_postcode: "",
          mailing_suburb: "",
          mailing_state: "",
          au_states: ['NSW','WA','QLD','SA','VIC','TAS','NT','ACT'], 
          dictionary: {
                custom: {
                    residential_street_number: {
                        required: () => 'Street number is required to proceed',
                        max: 'Cannot exceed more than 10 characters'
                    },
                    residential_street_address: {
                        required: () => 'Street address is required to proceed',
                        max: 'Cannot exceed more than 255 characters'
                    },
                    residential_postcode: {
                        required: () => 'Postcode is required to proceed',
                        max: 'Cannot exceed more than 4 characters'
                    },
                    residential_suburb: {
                        required: () => 'Suburb is required to proceed',
                        max: 'Cannot exceed more than 60 characters'
                    },
                    residential_state: {
                       required: () => 'State is required to proceed'
                    }
                }
            }
       }),
       computed: {
          AllFieldsValid: function() {
            let _isvalid = false;
            let fld = this.fields;
            if(fld.residential_street_number) {
               if(fld.residential_street_number.valid && fld.residential_street_address.valid && fld.residential_suburb.valid && fld.residential_state.valid && fld.residential_postcode.valid) {
                  // && fld.mailing_street_number.valid && fld.mailing_street_address.valid && fld.mailing_postcode.valid && fld.mailing_suburb.valid && fld.mailing_state.valid
                  _isvalid = true;
               }
            }
            return _isvalid;
         }
          /*
          mailing_street_number: function() {
             let _streetnumber = this.mailing_street_number;
             if(this.issameaddress) {
                _streetnumber = this.residential_street_number;
             }
             return _streetnumber; 
          },
          mailing_street_address: function() {
             let _streetaddress = this.mailing_street_address;
             if(this.issameaddress) {
                _streetaddress = this.residential_street_address;
             }
             return _streetaddress; 
          },
          mailing_postcode: function() {
             let _postcode = this.mailing_postcode;
             if(this.issameaddress) {
                _postcode = this.residential_postcode;
             }
             return _postcode; 
          },
          mailing_suburb: function() {
             let _suburb = this.mailing_suburb;
             if(this.issameaddress) {
                _suburb = this.residential_suburb;
             }
             return _suburb; 
          },
          mailing_state: function() {
             let _suburb = this.mailing_state;
             if(this.issameaddress) {
                _suburb = this.residential_suburb;
             }
             return _suburb; 
          }
          */
       },
       methods: {
           ValidateAddress() {
              this.$validator.validateAll().then((result) => {
                if(result) {
                  this.$parent.ServiceInsuranceProcess.residential_street_number = this.residential_street_number;
                  this.$parent.ServiceInsuranceProcess.residential_street_address = this.residential_street_address;
                  this.$parent.ServiceInsuranceProcess.residential_postcode = this.residential_postcode;
                  this.$parent.ServiceInsuranceProcess.residential_suburb = this.residential_suburb;
                  this.$parent.ServiceInsuranceProcess.residential_state = this.residential_state;
                  this.$parent.ServiceInsuranceProcess.issameaddress = this.issameaddress;
                  this.$parent.ServiceInsuranceProcess.mailing_street_number = this.mailing_street_number;
                  this.$parent.ServiceInsuranceProcess.mailing_street_address = this.mailing_street_address;
                  this.$parent.ServiceInsuranceProcess.mailing_postcode = this.mailing_postcode;
                  this.$parent.ServiceInsuranceProcess.mailing_suburb = this.mailing_suburb;
                  this.$parent.ServiceInsuranceProcess.mailing_state = this.mailing_state;

                  this.$parent.ServiceNextStep(12,"ServiceTermsAndConditions");
                }
              });
           },
           ValidateSessionData() {
              if(this.$parent.ServiceInsuranceProcess.residential_street_address !== undefined) {
                 
                 let _eip = this.$parent.ServiceInsuranceProcess;
                 this.residential_street_number = _eip.residential_street_number;
                 this.residential_street_address = _eip.residential_street_address;
                 this.residential_postcode = _eip.residential_postcode;
                 this.residential_suburb = _eip.residential_suburb;
                 this.residential_state = _eip.residential_state;
                 this.issameaddress = _eip.issameaddress;
                 this.mailing_street_number = _eip.mailing_street_number;
                 this.mailing_street_address = _eip.mailing_street_address;
                 this.mailing_postcode = _eip.mailing_postcode;
                 this.mailing_suburb = _eip.mailing_suburb;
                 this.mailing_state = _eip.mailing_state;
                 this.$validator.validateAll(); /* this was added to add success state on fields and buttons */
              }
           },
           UpdateSameAddress() {
              if(this.issameaddress) {
                 this.mailing_street_number = this.residential_street_number;
                 this.mailing_street_address = this.residential_street_address;
                 this.mailing_postcode = this.residential_postcode;
                 this.mailing_suburb = this.residential_suburb;
                 this.mailing_state = this.residential_state;
              } 
           }
       },
       mounted () {
         this.$validator.localize('en', this.dictionary) 
         this.$parent.CheckWindowPathName();
         this.ValidateSessionData();
         this.$parent.CurrentProcess = "ServiceInsuranceProcess";
       }
   }